import { invoke } from '@tauri-apps/api/tauri';
import { listen } from '@tauri-apps/api/event';
import { SystemScanResult, PersonaConfig, ChittyModule } from '../types';

export class TauriAPI {
  static async scanSystem(): Promise<SystemScanResult> {
    return await invoke('scan_system');
  }

  static async getPersonaConfigs(): Promise<PersonaConfig[]> {
    return await invoke('get_persona_configs');
  }

  static async applyPersonaConfig(personaId: string): Promise<void> {
    return await invoke('apply_persona_config', { personaId });
  }

  static async getAvailableModules(): Promise<ChittyModule[]> {
    return await invoke('get_available_modules');
  }

  static async installModule(moduleId: string): Promise<void> {
    return await invoke('install_module', { moduleId });
  }

  static async enableModule(moduleId: string, enabled: boolean): Promise<void> {
    return await invoke('enable_module', { moduleId, enabled });
  }

  static async configureModule(moduleId: string, config: Record<string, any>): Promise<void> {
    return await invoke('configure_module', { moduleId, config });
  }

  static async generateClaudeConfig(): Promise<void> {
    return await invoke('generate_claude_config');
  }

  static async testIntegration(service: string): Promise<boolean> {
    return await invoke('test_integration', { service });
  }

  static async getSystemHealth(): Promise<Record<string, any>> {
    return await invoke('get_system_health');
  }

  static onProgress(callback: (progress: { step: string; percentage: number; message: string }) => void) {
    return listen('progress', (event) => {
      callback(event.payload as { step: string; percentage: number; message: string });
    });
  }

  static onModuleStatusChange(callback: (status: { moduleId: string; status: string; message?: string }) => void) {
    return listen('module-status-change', (event) => {
      callback(event.payload as { moduleId: string; status: string; message?: string });
    });
  }
}